import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';

function Footer(props) {
    const mounted = useRef(false);
    useEffect(() => {
        mounted.current = true;
        return () => (mounted.current = false);
    });

    const { version } = props;

    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const isReadingPlex = hostname.includes('readingplex');
    const isMember = hostname.includes('member.');
    const portalName = isReadingPlex ? 'ReadingPlex' : 'MathPlex';
    const portalType = isMember ? 'Member' : 'Admin';

    return (
        <div className="flex flex-row w-full bg-black text-white text-base px-8 py-3 relative">
            <div>
                Changing Kids Future Everyday
            </div>
            <div className="ml-auto">
                &copy; {(new Date()).getFullYear()} MathPlex ReadingPlex LLC
            </div>
        </div>
    );
}

export default connect(null, {

})(Footer);